import { useDispatch } from 'react-redux';
import { Link, useNavigate } from "react-router-dom"; 
import red_line from '../../img/red_line.png';
import HeaderIndex from './components/HeaderIndex';
import Footer from '../../components/footer/Footer';
import Image from './components/Image';
import Header from '../../components/header/Header';
import './Index.css';
import RadioButton from '../../components/common/radioButton/RadioButton';
function Index() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const customersChoice = () => {
    navigate("/customers");
  };

  const checkStatus = () => {
    navigate("/status");
  };

  return (
    <div className='start-page'>
      <HeaderIndex />
      <div className='frame-774'>
        <div className='frame-775'>
          <div className='why-PRO'>
            <div className='title-header'>
              <img src={red_line} style={{ left: '-10px' }} className='red-line' />
              <h3 className='header-text'>
                system elektronicznej<br /> rejestracji reklamacji
              </h3>
              {/* <div className="holiday-text">
            <h4>
              Niniejszym informujemy, że: <br />
              <ul>
                <li>
                  <u>
                    w okresie 18.12.2023 r. - 05.01.2024 r  nastąpi przerwa w
                    obsłudze reklamacji.
                  </u>
                </li>
                <li>
                  Reklamacje zarejestrowane w systemie do dnia 15.12.2023 r.
                  będą jeszcze odbierane od klientów do 19.12.2023 r. ale
                  rozpatrywane od 08.01.2024 r.
                </li>
                <li>
                  Reklamacje zarejestrowane w systemie od dnia 18.12.2023 r.
                  będą odbierane od klientów od 08.01.2024 r.
                </li>
              </ul>
              Przepraszamy za utrudnienia.
            </h4>
          </div> */}
            </div>

            <div className='start-buttons-container'>
              <button className='button-1' onClick={customersChoice}>
                Zgłoś reklamację
              </button>
              <button className='button-2' onClick={checkStatus}>
                Sprawdź status
              </button>
            </div>
          </div>

          <div className='frame-772'>
            <div className='frame-773'>
              <p className='text-773'>
                Chcesz odpłatnie skalibrować lub naprawić produkty PRO?
              </p>
              <button className='btn-773' onClick={customersChoice}>
                Zgłoś sprzęt do naprawy
              </button>
              <br/>
              <div className='holiday-text'>
              {/* <h5>
                Szanowni Państwo */}
                {/* <br/><br/> 
                Uprzejmie informujemy, że w związku z przenosinami naszego serwisu do nowej lokalizacji tymczasowo mogą występować opóźnienia w rozpatrywaniu zgłoszeń reklamacyjnych oraz świadczeniu odpłatnych usług serwisowych. 
                <br/><br/>
                Zapewniamy, że dokładamy wszelkich starań, aby jak najszybciej uruchomić nowe centrum serwisowe i wznowić pełną obsługę. 
                <br/><br/>
                Prosimy o wyrozumiałość i cierpliwość w tym okresie. Przepraszamy za wszelkie niedogodności jakie to może spowodować.
                <br/><br/>
                Jednocześnie jesteśmy przekonani, że nasza nowa lokalizacja umożliwi nam jeszcze bardziej efektywne i sprawne świadczenie usług. 
                <br/><br/>
                Dziękujemy za zrozumienie i pozostajemy do Państwa dyspozycji w razie dodatkowych pytań. */}
                {/* <br/><br/> 
                Niniejszym informujemy, że:
                <br/><br/>
                w okresie <u>23.12.2024 r. - 06.01.2025 r</u> nastąpi przerwa w obsłudze reklamacji.   
                <br/><br/>
                Reklamacje zarejestrowane w systemie do dnia <u>17.12.2024 r.</u> będą jeszcze odbierane od klientów do <u>19.12.2024 r.</u> ale rozpatrywane od <u>07.01.2025 r.</u>    
                <br/><br/>
                Reklamacje zarejestrowane w systemie od dnia 18.12.2024 r. będą odbierane od klientów od <u>08.01.2025 r.</u>                 
                <br/><br/>
                Przepraszamy za utrudnienia.              
                </h5> */}
                  {/* <h5 style={{color:'black'}}>        
                  Z przyjemnością informujemy, że nasz serwis przenosi się do nowej, nowocześniejszej lokalizacji, co pozwoli nam jeszcze lepiej odpowiadać na Państwa potrzeby.<br/> 
                  Dokładamy wszelkich starań, aby minimalizować ewentualne niedogodności, jednak prosimy o wyrozumiałość i cierpliwość w tym okresie przejściowym. Wierzymy, że nowa lokalizacja umożliwi nam jeszcze bardziej efektywne i sprawne świadczenie usług.<br/><br/>
                  Jeśli mają Państwo jakiekolwiek pytania lub potrzebują dodatkowych informacji, zachęcamy do kontaktu z naszym zespołem.<br/>
                  </h5>     */}
              </div>
            </div>
          </div>
         
        </div>
      </div>
      <Image />
      <Footer />
    </div>
  );
}

export default Index;